import Button from './button';
import ButtonGroup from './button-group';

export { ButtonProps, ButtonShape, ButtonSize, ButtonType } from './button';
export { ButtonGroupProps } from './button-group';

Button.Group = ButtonGroup;
export default Button;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/view/view-abutton/index.tsx